export default __webpack_public_path__ + "static/media/screen_zendesk_2.f1305992.png";